import {
  Box,
  BoxProps,
  Flex,
  Heading,
  SegmentTabs,
  Tab,
  TabList,
  Tooltip,
} from '@modusign/design-system';
import { ReactNode } from 'react';

import HelpButton from '@app/components/HelpButton';
import MyProfile from '@app/components/MyProfile';
import useResponsiveValue from '@app/hooks/useResponsiveValue';
import josa from '@app/libs/josa';

interface MainPageHeaderProps extends BoxProps<'div'> {
  title: string;
  tooltipMessage?: string;
  tab?: { tabs: [string, string]; index: 0 | 1; onChange: (index: 0 | 1) => void };
  children?: ReactNode;
}

export default function MainPageHeader({
  title,
  tooltipMessage,
  tab,
  children,
  ...props
}: MainPageHeaderProps) {
  const isDesktop = useResponsiveValue([false, false, true]);

  return (
    <Flex
      alignItems="center"
      borderBottom="1px solid"
      borderBottomColor="navigationBorderNeutralBase"
      flexWrap="wrap"
      height="60px"
      justifyContent="space-between"
      px={[4, 4, 9]}
      {...props}
    >
      <Flex
        alignItems="center"
        flex="none"
        gap={5}
        height="60px"
        justifyContent={['space-between', null, 'flex-start']}
      >
        <Heading as="h1" fontSize="xl" fontWeight="medium">
          {title}
        </Heading>
        {tab && (
          <Tooltip
            content={tooltipMessage ?? `모든 ${josa(title, '과/와')} 내가 생성한 ${title} 구분`}
            delay={{ open: 1000, close: 0 }}
            placement="bottom"
            scale="md"
          >
            <Box>
              <SegmentTabs
                index={tab.index}
                width="180px"
                onChange={(index) => tab.onChange(index === 0 ? 0 : 1)}
              >
                <TabList>
                  {tab.tabs.map((t) => (
                    <Tab key={t}>{t}</Tab>
                  ))}
                </TabList>
              </SegmentTabs>
            </Box>
          </Tooltip>
        )}
      </Flex>
      <Flex alignItems="center" display={['none', null, 'flex']}>
        {children}
        <Box ml={7} />
        <MyProfile />
        {isDesktop && <HelpButton variant="basic" />}
      </Flex>
    </Flex>
  );
}
